import { Box, HStack, Text, VStack } from "@chakra-ui/react"
import { format } from "date-fns"
import { Tarefa } from "../../../../types/tarefas"
import { formatDateDistance } from "../../../../utils/functions/format-date"

export interface VisualizarAviso {
    data: Tarefa
}

export const VisualizarTarefaC = ({ data }: VisualizarAviso) => {

    return (
        <VStack
            w={`100%`}
            spacing={5}
            display={`flex`}
            alignItems={`flex-start`}
        >
            <VStack
                w={`100%`}
                spacing={2}

            >
                <Text
                    w={`100%`}
                    textAlign={`start`}
                    color={`gray.500`}
                    fontWeight={`bold`}
                >
                    Título:
                </Text>
                <Box
                    w={`100%`}
                    maxH={`250px`}
                    overflowY={`auto`}
                    borderRadius={10}
                    borderWidth={1}
                    borderColor={`gray.200`}
                    p={3}
                >
                    <Text color={`gray.600`}>{data?.titulo}</Text>
                </Box>
            </VStack>

            <VStack
                w={`100%`}
                spacing={2}

            >
                <Text
                    w={`100%`}
                    textAlign={`start`}
                    color={`gray.500`}
                    fontWeight={`bold`}
                >
                    Descrição:
                </Text>
                <Box
                    w={`100%`}
                    maxH={`250px`}
                    overflowY={`auto`}
                    borderRadius={10}
                    borderWidth={1}
                    borderColor={`gray.200`}
                    p={3}
                >
                    <Text color={`gray.600`}>{data?.descricao}</Text>
                </Box>
            </VStack>


            {data && data?.data &&
                <VStack
                    w={`100%`}
                    spacing={2}

                >
                    <Text
                        w={`100%`}
                        textAlign={`start`}
                        color={`gray.500`}
                        fontWeight={`bold`}
                    >
                        Data:
                    </Text>
                    <Box
                        w={`100%`}
                        borderRadius={10}
                        borderWidth={1}
                        borderColor={`gray.200`}
                        p={3}
                    >
                        <Text color={`gray.700`}>{data?.data && formatDateDistance(data?.data)}</Text>
                    </Box>
                </VStack>
            }

            {data && data?.data_de &&
                <VStack
                    w={`100%`}
                    spacing={2}

                >
                    <Text
                        w={`100%`}
                        textAlign={`start`}
                        color={`gray.500`}
                        fontWeight={`bold`}
                    >
                        Período:
                    </Text>
                    <HStack
                        w={`100%`}
                        spacing={2}
                    >

                        <Box
                            w={`100%`}
                            borderRadius={10}
                            borderWidth={1}
                            borderColor={`gray.200`}
                            p={3}
                        >

                            <VStack
                                w={`100%`}
                                alignItems={`flex-start`}
                                justifyContent={`flex-start`}
                                spacing={2}
                            >
                                <Text color={`gray.700`}>{`De: ${format(new Date(data?.data_de), "dd/MM/yyyy 'ás' HH:mm")}`}</Text>


                            </VStack>
                        </Box>
                        <Box
                            w={`100%`}
                            borderRadius={10}
                            borderWidth={1}
                            borderColor={`gray.200`}
                            p={3}
                        >
                            <Text color={`gray.700`}>{`Até: ${format(new Date(data?.data_ate), "dd/MM/yyyy 'ás' HH:mm")}`}</Text>
                        </Box>
                    </HStack>
                </VStack>

            }

            <HStack
                w={`100%`}
                spacing={5}
                alignItems={`baseline`}
                justifyContent={`flex-end`}
            >
                {data?.enviado_por &&
                    <Text
                        textAlign={`end`}
                        color={`gray.500`}
                        fontWeight={700}
                        fontStyle={`italic`}
                        fontSize={10}
                    >
                        Fixado por {data?.enviado_por}&nbsp;{data?.created && "em " + format(new Date(data?.created), "dd/MM/yyyy 'ás' HH:mm")}
                    </Text>
                }

            </HStack>
        </VStack>
    )
}